import {useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";
import React, {useEffect} from "react";
import $ from "jquery";
import axios from "axios";
import "../../assets/css/pages/stores.css";
import swal from "sweetalert";

export default function () {
    const navigate = useNavigate();
    const token = useSelector(state => state.token);
    const user = useSelector(state => state.user);

    const deleteRow = (table, selector) => {
        table
            .row(selector.parents('tr'))
            .remove()
            .draw(false);
    }

    useEffect(() => {

        const baseUrl = process.env.REACT_APP_API_CLEAN_URL;

        let table = $('#stores').DataTable({
            "ajax": {
                url: process.env.REACT_APP_API_URL + "shop-addresses",
                method: 'GET',
                beforeSend: function (request) {
                    request.setRequestHeader("Authorization", 'Bearer ' + token);
                },
                error: function (xhr) {
                    if (xhr?.status === 401) {
                        axios.defaults.baseURL = baseUrl;
                        axios.post('/logout')
                            .then(
                                localStorage.removeItem('persist:root'),
                                navigate('/login')
                            );
                    }
                }
            },
            "columns": [
                { data: 'id', name: 'id' },
                { data: 'shop', name: 'shop'},
                { data: 'name', name: 'name' },
                { data: 'town.name', name: 'town.name', defaultContent: "" },
                { data: 'town.region.name', name: 'town.region.name',defaultContent:'' },
                { data: 'address', name: 'address' },
                { data: 'code', name: 'code' },
                {
                    data: 'actions',
                    orderable: false,
                    searchable: false,
                    render: function (data, type, row) {
                        return `
                    <button type="button"
                        class="btn-primary me-2 mb-2 actions">
                            Actions
                            <i class="fas fa-caret-down"></i>
                    </button>
                    <div class="row-actions display-none hidden-actions">
                        <div class="absolute-div">
                            <button 
                            class="btn btn-primary me-2 mb-4 mt-1 edit"
                            row-id="${row.id}" row-name="${row.name}">
                                <i class="fas fa-edit"></i> Edit
                            </button>
                            <button 
                            class="btn btn-danger me-2 mb-1 delete"
                            row-id="${row.id}" row-name="${row.name}">
                                <i class="far fa-trash-alt"></i> Delete
                            </button>
                        <div>
                    </div>
                    `;
                    },
                }
            ],
            "order": [[0, "desc"]],
        });

        table.column(1).visible(user.roles.includes('Super Admin'))

        table.on('click', 'button.actions', function () {
            if ($(this).next(".row-actions").hasClass("hidden-actions")) {
                $(this).next(".row-actions").fadeIn(100).removeClass("hidden-actions");
            } else {
                $(this).next(".row-actions").fadeOut(100).addClass("hidden-actions");
            }
        });

        table.on('click', 'button.delete', function () {
            const id = ($(this).attr("row-id"));
            const name = ($(this).attr("row-name"));
            $(".row-actions").fadeOut(100).addClass("hidden-actions");
            deleteStore(id, name, table, $(this));
        });

        table.on('click', 'button.edit', function () {
            const id = ($(this).attr("row-id"));
            navigate('/stores/' + id + '/edit');
        });

        let datatableSearch = ".dataTables_wrapper .dataTables_filter input[type=search]";
        $("<i class='fas fa-search'></i>")
            .insertBefore(datatableSearch);
        $(datatableSearch)
            .attr("placeholder", "Search...");
    }, []);

    const addStore = () => {
        navigate('/stores/create');
    }
    const deleteStore = (id, name, table, selector) => {
        swal({
            title: "Are you sure?",
            text: 'You want to delete Store "' + name + '"?',
            icon: "warning",
            buttons: true,
            dangerMode: true,
            confirm: {
                text: "Yes",
                value: true,
                visible: true,
                className: "",
                closeModal: true
            }
        }).then((result) => {
            if (result == true) {
                axios.delete('shop-addresses/' + id, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + token
                    }
                }).then(function (res) {
                    if (res.status == 200) {
                        swal('The Store "' + name + '" has been deleted!', {
                            icon: "success",
                        });
                        deleteRow(table, selector);
                        return true;
                    } else {
                        return false;
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            }
        });
    }

    return (
        <>
            <div>
                <div className="d-flex flex-stack mb-5">
                    <div className="d-flex justify-content-end" data-kt-docs-table-toolbar="base">
                        <button type="button"
                                className="btn btn-primary"
                                data-bs-toggle="tooltip"
                                title="Coming Soon"
                                onClick={addStore}
                        >
                            Add Store
                        </button>
                        {/*end::Add store*/}
                    </div>
                </div>
                {/*end::Wrapper*/}
                {/*begin::Datatable*/}
                <table id="stores" className="table align-middle table-row-dashed fs-6 gy-5">
                    <thead>
                    <tr className="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
                        <th>ID</th>
                        <th>Merchant</th>
                        <th>Name</th>
                        <th>City</th>
                        <th>Region</th>
                        <th>Address</th>
                        <th>Code</th>
                        <th>Actions</th>
                    </tr>
                    </thead>
                    <tbody className="text-gray-600 fw-bold">
                    </tbody>
                </table>
            </div>
        </>
    );

}